//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import pieChart from '@/views/assets/pieChart'
export default {
  name: 'Department',
  extends: vComponent,
  components: { pieChart },
  props: {
    items: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      columns: [ // 欄位宣告
        { name: 'GP_NAME', label: '品名GP_NAME', field: 'GP_NAME' },
        { name: 'DP_NAME1', label: '品名DP_NAME1', field: 'DP_NAME1' },
        { name: 'PSENT', label: '百分比', field: 'PSENT' },
        { name: 'MAVG', label: '平均單價', field: 'MAVG' }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 20 // 0 means all rows
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
